import { getSortingResult } from '@touche-lts/panel-ui/dist'
import { makeObservable } from 'mobx'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { UserDTO } from 'models'
import moment from 'moment'
import { getUserFullName } from '../users-main-store'
import {
  UsersInStoreTableSearchProps,
  UsersInStoreTableSortProps
} from './users-in-store-table-store.types'
import {
  initialUsersInStoreTablePaginationProps,
  initialUsersInStoreTableSearchProps,
  usersInStoreTableNeedTimeoutProps
} from './users-in-store-table-store.utils'

export class UsersInStoreTableStore extends PaginationSearchBase<
  UsersInStoreTableSortProps,
  UsersInStoreTableSearchProps,
  UserDTO
> {
  public users: UserDTO[] = []

  constructor () {
    super({
      initialPaginationProps: initialUsersInStoreTablePaginationProps,
      initialSearchProps: initialUsersInStoreTableSearchProps,
      needTimeoutProps: usersInStoreTableNeedTimeoutProps
    })
    makeObservable(this, {
      users: false,
      setUsers: false
    })
  }

  //METHODS
  public clearStore = (): void => {
    this.setUsers([])
    this.clearPaginationSearchBaseStore()
  }

  public setUsers = (users: UserDTO[]): void => {
    this.users = users
    const totalElements = users.length
    this.setPaginationProps({
      totalElements,
      totalPages: Math.floor(totalElements / this.pagination.size) + 1
    })
  }

  public triggerSearch: TriggerSearchFunc = (options): void => {
    const { name, role, addedOnPeriod } = this.searchProps

    const applyFilters = (user: UserDTO): boolean => {
      const nameFilter = name
        ? getUserFullName(user)
            .toLowerCase()
            .includes(name.trim().toLocaleLowerCase())
        : true
      const roleFilter = role ? user.role?.id === role.id : true
      const addedOnFilter = addedOnPeriod
        ? moment(user.created).isBetween(
            addedOnPeriod.start,
            addedOnPeriod.end,
            undefined,
            '[]'
          )
        : true
      return nameFilter && roleFilter && addedOnFilter
    }

    const results = this.users.filter(applyFilters)

    const { sortProp, sortDirection } = this.pagination
    results.sort((a, b) => {
      let valueA, valueB
      switch (sortProp) {
        case UsersInStoreTableSortProps.NAME:
          valueA = getUserFullName(a)
          valueB = getUserFullName(b)
          break
        case UsersInStoreTableSortProps.ROLE:
          valueA = a.role?.label
          valueB = b.role?.label
          break
        case UsersInStoreTableSortProps.DATE:
          valueA = new Date(a.created.valueOf())
          valueB = new Date(b.created.valueOf())
          break
        default:
          break
      }

      return getSortingResult(valueA, valueB, sortDirection)
    })
    const { page: currentPagePaginationSetting, size } = this.pagination
    const page = options?.resetPageNumber ? 0 : currentPagePaginationSetting
    this.setPaginationProps({
      page,
      totalElements: results.length,
      totalPages: Math.ceil(results.length / size)
    })
    const startIndex = page * size
    const endIndex = startIndex + size
    this.setSearchResults(results.slice(startIndex, endIndex))
  }
}
